var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMedal = function SvgIconMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1316CF",
    d: "M8.5 10.5c2.485 0 4.5-1.94 4.5-4.334s-2.015-4.333-4.5-4.333S4 3.773 4 6.166 6.015 10.5 8.5 10.5M11.027 10.906c.22-.113.473.054.473.3v3.234c0 .6-.42.893-.94.646l-1.787-.846a.77.77 0 0 0-.546 0l-1.787.846c-.52.24-.94-.053-.94-.653l.013-3.227c0-.246.26-.406.474-.3.753.38 1.606.594 2.513.594a5.64 5.64 0 0 0 2.527-.594"
  })));
};
export default SvgIconMedal;